import _construct from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/construct.js";
import _defineProperty from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { TZDateMini } from "./mini.js";

/**
 * UTC date class. It maps getters and setters to corresponding UTC methods,
 * forcing all calculations in the UTC time zone.
 *
 * Combined with date-fns, it allows using the class the same way as
 * the original date class.
 *
 * This complete version provides not only getters, setters,
 * and `getTimezoneOffset`, but also the formatter functions, mirroring
 * all original `Date` functionality. Use this version when you need to format
 * a string or in an environment you don't fully control (a library).
 * For a minimal version, see `UTCDateMini`.
 */
export var TZDate = /*#__PURE__*/function (_TZDateMini) {
  function TZDate() {
    _classCallCheck(this, TZDate);
    return _callSuper(this, TZDate, arguments);
  }
  _inherits(TZDate, _TZDateMini);
  return _createClass(TZDate, [{
    key: "toISOString",
    value:
    //#endregion

    //#region representation

    function toISOString() {
      var _this$tzComponents = this.tzComponents(),
        _this$tzComponents2 = _slicedToArray(_this$tzComponents, 3),
        sign = _this$tzComponents2[0],
        hours = _this$tzComponents2[1],
        minutes = _this$tzComponents2[2];
      var tz = "".concat(sign).concat(hours, ":").concat(minutes);
      return this.internal.toISOString().slice(0, -1) + tz;
    }
  }, {
    key: "toString",
    value: function toString() {
      // "Tue Aug 13 2024 07:50:19 GMT+0800 (Singapore Standard Time)";
      return "".concat(this.toDateString(), " ").concat(this.toTimeString());
    }
  }, {
    key: "toDateString",
    value: function toDateString() {
      // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
      var _this$internal$toUTCS = this.internal.toUTCString().split(" "),
        _this$internal$toUTCS2 = _slicedToArray(_this$internal$toUTCS, 4),
        day = _this$internal$toUTCS2[0],
        date = _this$internal$toUTCS2[1],
        month = _this$internal$toUTCS2[2],
        year = _this$internal$toUTCS2[3];
      // "Tue Aug 13 2024"
      return "".concat(day === null || day === void 0 ? void 0 : day.slice(0, -1) /* Remove "," */, " ").concat(month, " ").concat(date, " ").concat(year);
    }
  }, {
    key: "toTimeString",
    value: function toTimeString() {
      // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
      var time = this.internal.toUTCString().split(" ")[4];
      var _this$tzComponents3 = this.tzComponents(),
        _this$tzComponents4 = _slicedToArray(_this$tzComponents3, 3),
        sign = _this$tzComponents4[0],
        hours = _this$tzComponents4[1],
        minutes = _this$tzComponents4[2];
      // "07:42:23 GMT+0800 (Singapore Standard Time)"
      return "".concat(time, " GMT").concat(sign).concat(hours).concat(minutes, " (").concat(tzName(this.timeZone, this), ")");
    }
  }, {
    key: "toLocaleString",
    value: function toLocaleString(locales, options) {
      return Date.prototype.toLocaleString.call(this, locales, _objectSpread(_objectSpread({}, options), {}, {
        timeZone: (options === null || options === void 0 ? void 0 : options.timeZone) || this.timeZone
      }));
    }
  }, {
    key: "toLocaleDateString",
    value: function toLocaleDateString(locales, options) {
      return Date.prototype.toLocaleDateString.call(this, locales, _objectSpread(_objectSpread({}, options), {}, {
        timeZone: (options === null || options === void 0 ? void 0 : options.timeZone) || this.timeZone
      }));
    }
  }, {
    key: "toLocaleTimeString",
    value: function toLocaleTimeString(locales, options) {
      return Date.prototype.toLocaleTimeString.call(this, locales, _objectSpread(_objectSpread({}, options), {}, {
        timeZone: (options === null || options === void 0 ? void 0 : options.timeZone) || this.timeZone
      }));
    }

    //#endregion

    //#region private
  }, {
    key: "tzComponents",
    value: function tzComponents() {
      var offset = this.getTimezoneOffset();
      var sign = offset > 0 ? "-" : "+";
      var hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
      var minutes = String(Math.abs(offset) % 60).padStart(2, "0");
      return [sign, hours, minutes];
    }

    //#endregion
  }, {
    key: "withTimeZone",
    value: function withTimeZone(timeZone) {
      return new TZDate(+this, timeZone);
    }

    //#region date-fns integration
  }, {
    key: Symbol.for("constructDateFrom"),
    value: function value(date) {
      return new TZDate(+new Date(date), this.timeZone);
    }

    //#endregion
  }], [{
    key: "tz",
    value:
    //#region static

    function tz(_tz) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return args.length ? _construct(TZDate, args.concat([_tz])) : new TZDate(Date.now(), _tz);
    }
  }]);
}(TZDateMini);
function tzName(tz, date) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: tz,
    timeZoneName: "long"
  }).format(date).slice(12);
}